import React from "react";
import person from "../../assets/Images/person.jpg";
import { RiVerifiedBadgeFill } from "react-icons/ri";

function Testimony() {
  return (
    <div className="relative h-[calc(100vh-100px)] overflow-hidden">
      <div className="flex flex-col items-center justify-center h-full">
        <h1 className="text-[30px] font-semibold font-Gilroy bg-clip-text bg-gradient-to-r from-[#EAEAEA] to-[#848484] text-transparent mb-16 tracking-wide w-fit">
          Testimony
        </h1>

        <div className="absolute inset-y-0 -left-32 h-full w-[500px] rounded-full bg-black blur-[150px] flex-shrink-0 z-20" />
        <div className="absolute inset-y-0 -right-32 h-full w-[500px] rounded-full bg-black blur-[150px] flex-shrink-0 z-20" />

        <div className="grid w-full grid-cols-3 gap-16 px-28 flex-nowrap">
          <div className="h-60 rounded-3xl bg-gradient-to-b from-[#505050] to-transparent flex-shrink-0 p-px grayscale">
            <div className="rounded-[calc(1.5rem-1px)] bg-[#0E0E0E] backdrop-blur-xl w-full h-full p-8 relative overflow-hidden">
              <div className="absolute -top-10 -right-0 w-[100px] h-[200px] rotate-[37.5deg] bg-[#2CA1BE]/50 rounded-full blur-[60px]" />
              <div className="absolute -bottom-20 left-10 w-[100px] h-[200px] rotate-[37.5deg] bg-[#9C7200]/50 rounded-full blur-[60px]" />
              <div className="flex items-center">
                <div className="w-14 h-14 bg-gradient-to-b from-white via-[#393939] to-[#393939]/20 rounded-full p-1">
                  <img
                    src={person}
                    alt="testimonial person"
                    className="object-cover object-top w-full h-full rounded-full"
                  />
                </div>

                <p className="ml-5 font-medium tracking-wide text-gray-200">
                  Adam Markos
                </p>

                <RiVerifiedBadgeFill
                  size={20}
                  className="ml-2 text-gray-200 "
                />
              </div>

              <div className="mt-5 text-[#C1C1C1] font-medium text-nav mix-blend-color-dodge">
                I really love their customer service and deliverability product
                as they promised...{" "}
              </div>

              <p className="flex items-end justify-end mt-5 text-[#C1C1C1] font-medium text-nav mix-blend-color-dodge">
                CEO Elevate Dream
              </p>
            </div>
          </div>

          <div className="h-60 rounded-3xl bg-gradient-to-b from-[#505050] to-transparent flex-shrink-0 p-px ">
            <div className="rounded-[calc(1.5rem-1px)] bg-[#0E0E0E] backdrop-blur-xl w-full h-full p-8 relative overflow-hidden">
              <div className="absolute -top-10 -right-0 w-[100px] h-[200px] rotate-[37.5deg] bg-[#2CA1BE]/50 rounded-full blur-[60px]" />
              <div className="absolute -bottom-20 left-10 w-[100px] h-[200px] rotate-[37.5deg] bg-[#9C7200]/50 rounded-full blur-[60px]" />
              <div className="flex items-center">
                <div className="w-14 h-14 bg-gradient-to-b from-white via-[#393939] to-[#393939]/20 rounded-full p-1">
                  <img
                    src={person}
                    alt="testimonial person"
                    className="object-cover object-top w-full h-full rounded-full"
                  />
                </div>

                <p className="ml-5 font-medium tracking-wide text-gray-200">
                  Adam Daniel
                </p>

                <RiVerifiedBadgeFill
                  size={20}
                  className="ml-2 text-gray-200 "
                />
              </div>

              <div className="mt-5 text-[#C1C1C1] font-medium text-nav mix-blend-color-dodge">
                I really love their customer service and deliverability product
                as they promised...{" "}
              </div>

              <p className="flex items-end justify-end mt-5 text-[#C1C1C1] font-medium text-nav mix-blend-color-dodge">
                CEO Elevate Dream
              </p>
            </div>
          </div>

          <div className="h-60 rounded-3xl bg-gradient-to-b from-[#505050] to-transparent flex-shrink-0 p-px grayscale">
            <div className="rounded-[calc(1.5rem-1px)] bg-[#0E0E0E] backdrop-blur-xl w-full h-full p-8 relative overflow-hidden">
              <div className="absolute -top-10 -right-0 w-[100px] h-[200px] rotate-[37.5deg] bg-[#2CA1BE]/50 rounded-full blur-[60px]" />
              <div className="absolute -bottom-20 left-10 w-[100px] h-[200px] rotate-[37.5deg] bg-[#9C7200]/50 rounded-full blur-[60px]" />
              <div className="flex items-center">
                <div className="w-14 h-14 bg-gradient-to-b from-white via-[#393939] to-[#393939]/20 rounded-full p-1">
                  <img
                    src={person}
                    alt="testimonial person"
                    className="object-cover object-top w-full h-full rounded-full"
                  />
                </div>

                <p className="ml-5 font-medium tracking-wide text-gray-200">
                  Adam Markos
                </p>

                <RiVerifiedBadgeFill
                  size={20}
                  className="ml-2 text-gray-200 "
                />
              </div>

              <div className="mt-5 text-[#C1C1C1] font-medium text-nav mix-blend-color-dodge">
                I really love their customer service and deliverability product
                as they promised...{" "}
              </div>

              <p className="flex items-end justify-end mt-5 text-[#C1C1C1] font-medium text-nav mix-blend-color-dodge">
                CEO Elevate Dream
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimony;
